import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { axiosReq } from "@/lib/axios";
import { useNavigate } from "react-router-dom";
import { queryClient } from "@/lib/react-query";

export const useCreateStories = () => {

  const navigate = useNavigate()

  const request = async ({ image_id, description }
    : { image_id: number, description: string })
    : Promise<{
      data: {
        event_id: number,
        image_id: number,
      }
    }> => {
    const response = await axiosReq.post("/api/asset/create-image-posts/", { image_id, description });
    return response.data
  }

  const { mutate: createStory, status } = useMutation({
    mutationFn: request,
    onSuccess: (data) => {
      toast.message("Stories created, see you there...")
      if (data) {
        navigate(`/home?curr=story&theme=${data.data.event_id}&i=${data.data.image_id}`)
        queryClient.invalidateQueries({queryKey: ["themes"]})
      }
    }
  })

  return { createStory, status }

}
